/**
 * @author Leonel Martinez
 * @fileoverview Vue mixing used globally for general purposes.
 */
import {hasNestedProperty, ROUTES, searchForState} from "@/utils";
import i18n from "@/i18n";
import Vue from 'vue';

export const helpersMixin = {
  computed: {
    // Watch the current window size at any time
    $isMobileDevice: () => ['sm', 'xs', 'md'].includes(Vue.prototype.$vuetify.breakpoint.name),
    $isSmallDevice: () => ['sm', 'xs'].includes(Vue.prototype.$vuetify.breakpoint.name),
    $isOnlySmallDevice: () => ['sm'].includes(Vue.prototype.$vuetify.breakpoint.name),
    $isPhoneDevice: () => ['xs'].includes(Vue.prototype.$vuetify.breakpoint.name),
    $isTabletDevice: () => ['sm','md'].includes(Vue.prototype.$vuetify.breakpoint.name),
    $isDesktopDevice: () => ['lg', 'xl'].includes(Vue.prototype.$vuetify.breakpoint.name),
    $isUltraWideDevice: () => ['xl'].includes(Vue.prototype.$vuetify.breakpoint.name),
    // ROUTES be available in components
    $ROUTES: () => ROUTES,
    // Translate anything from the components
    $i18n: () => i18n
  },
  methods: {
    /**
     * @param  {object} args Pass all arguments from the imported method to the component scope
     */
    $hasNestedProperty(...args) {
      return hasNestedProperty(...args);
    },
    /**
     * @description Used mostly in tables along with paginations
     * @param {object} pagination
     * @param {object} column
     */
    $sortBy(pagination, column) {
      if (!pagination || !column) return
      if (pagination.sortBy === column) {
        pagination.descending = !pagination.descending;
      } else {
        pagination.sortBy = column;
        pagination.descending = false;
      }
    },
    /**
     * @description Get the calculation of extended costs in the templates that shold do this calc
     * @param {number} cost
     * @param {number} qty
     */
    $calculateExtendedCost(cost, qty) {
      const realCost = parseFloat(cost).toFixed(2);
      return parseFloat(realCost * qty);
    },

    $searchForState(string) {
      return searchForState(string);
    },

    /**
     * @description Get the IE version the user is using
     * @returns {number} IE version, -1 for any other browser.
     */
    $msieversion() {
      let ieVersion = -1;

      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');

      if (msie > 0) {
        // IE 10 or older, return version number

        ieVersion = parseInt(ua.substring(
          msie + 5, ua.indexOf('.', msie)), 10);
      }

      const trident = ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11, return version number

        const rv = ua.indexOf('rv:');
        ieVersion = parseInt(ua.substring(
          rv + 3, ua.indexOf('.', rv)), 10);
      }

      const edge = ua.indexOf('Edge/');
      if (edge > 0) {
        //Edge (IE 12+), return version number

        ieVersion = parseInt(ua.substring(
          edge + 5, ua.indexOf('.', edge)), 10);
      }
      // User uses other browser

      return ieVersion;
    },
  }
};
